exports = module.exports = require("../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".message-rich-message-e9b1c{position:relative}.message-rich-message-e9b1c .ee-icon-svg{top:1px}.message-message-1c37b{position:relative}.message-rich-text-wrapper-00a7b{margin-bottom:5px}.message-rich-text-wrapper-00a7b,.message-text-wrapper-11a73{padding-left:23px;text-align:left}.message-rich-title-a5388{text-align:left;font-size:14px;line-height:21px;color:#333}.message-title-a5af5{display:none}", ""]);

// Exports
exports.locals = {
	"rich-message": "message-rich-message-e9b1c",
	"richMessage": "message-rich-message-e9b1c",
	"message": "message-message-1c37b",
	"rich-text-wrapper": "message-rich-text-wrapper-00a7b",
	"richTextWrapper": "message-rich-text-wrapper-00a7b",
	"text-wrapper": "message-text-wrapper-11a73",
	"textWrapper": "message-text-wrapper-11a73",
	"rich-title": "message-rich-title-a5388",
	"richTitle": "message-rich-title-a5388",
	"title": "message-title-a5af5"
};